var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeppelinCodebarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71432 0.428711H4.62861V2.6312H3.71432V0.428711ZM5.77145 0.428711H6.68573V2.6312H5.77145V0.428711ZM9.54286 0.428711H10.1143V2.6312H9.54286V0.428711ZM11.2572 0.428711H12.1714V2.6312H11.2572V0.428711ZM13.8857 0.428711H13.3143V2.6312H13.8857V0.428711ZM13.8857 7.56714V3.85728H14.8572C15.015 3.85728 15.1429 3.72936 15.1429 3.57157C15.1429 3.41377 15.015 3.28585 14.8572 3.28585H13.8857H13.3143H12.1714H11.2572H10.1143H9.54286H8.40001H7.82858H6.68573H5.77145H4.62861H3.71432H2.57146H2.00003H1.14289C0.985096 3.28585 0.857178 3.41377 0.857178 3.57157C0.857178 3.72936 0.985096 3.85728 1.14289 3.85728H2.00003V7.56714H2.57146V3.85728H3.71432V7.56714H4.62861V3.85728H5.77145V7.56714H6.68573V3.85728H7.82858V7.56714H8.40001V3.85728H9.54286V7.56714H10.1143V3.85728H11.2572V7.56714H12.1714V3.85728H13.3143V7.56714H13.8857ZM8.40001 0.428711H7.82858V2.6312H8.40001V0.428711ZM2.57146 0.428711H2.00003V2.6312H2.57146V0.428711Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeppelinCodebarIcon);
export default __webpack_public_path__ + "static/media/zeppelin-codebar-icon.163de7cd.svg";
export { ForwardRef as ReactComponent };